export default __webpack_public_path__ + "static/media/project1.5caaa1de.png";